import Footer from './Footer';
import Header from './Header';

/* Styles */
import styles from 'styles/layout.module.scss';
import { isIE } from 'lib/browserDetect';

/* i18n */
import { useIntl } from 'react-intl';

const Layout =({children, locale, handleDrawerOpen, loggedIn}) => {

  const intl = useIntl();
  const testing = process.env.REACT_APP_TESTING;

  return(
      <div className={styles.layout}>
        <div>
          {isIE && (
            <div className={styles.browserBanner}>{intl.formatMessage({id: 'browsers.ie.banner'})}</div>
          )}
          {testing === '1' ? (
            <div className={styles.envBanner}>{intl.formatMessage({id: 'app.envBanner'})}</div>
          ):null}
          <Header locale={locale} handleDrawerOpen={handleDrawerOpen} loggedIn={loggedIn} />
          <main>{children}</main>
        </div>
        <Footer />
      </div>
  )
}

export default Layout;